import React from "react";
import { Select } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const TransferExemptionReason = () => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();
	const { details } = usePropertyContext();

	const handleSubmit = async () => {
		next();
	};

	const options = React.useMemo(
		() => [
			{
				label: "I am no longer the owner of the property.",
				value: "no_longer_own_property",
			},
			{
				label:
					"I own the property, but I no longer occupy the property as my principal residence.",
				value: "property_is_no_longer_my_primary_residence",
			},
			{
				label: "I have converted the property to a rental property.",
				value: "property_converted_to_rental_property",
			},
			{
				label: "I have converted the property to a commercial property.",
				value: "property_converted_to_commercial_property",
			},
		],
		[details]
	);

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p className="bold">Why are you transferring the exemption?</p>
				</div>
				<div className="mt-2" />
				<Select
					required
					label="Reason for Transfer"
					value={specialFieldsValue?.exemption_transfer_reason ?? ""}
					onChange={e =>
						setSpecialFieldsValue({ exemption_transfer_reason: e.target.value })
					}>
					<option value="" hidden disabled>
						Reason for Transfer
					</option>
					{options.map(({ label, value }) => (
						<option key={label} value={value}>
							{label}
						</option>
					))}
				</Select>
			</div>
			<ButtonV2
				size="large"
				disabled={!specialFieldsValue?.exemption_transfer_reason}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default TransferExemptionReason;
